import { MODULE_REQUEST, CREATE_MODULE, GET_MODULES, GET_MODULES_STRUCTURE, UPDATE_MODULE, DELETE_MODULE, MODULE_REQUEST_FAILURE, SET_PINNED_MODULES } from '../types';

const initialState = {
  modules: [],
  moduleStructure: [],
  pinnedModules: [],
  loading: false,
  error: null,
};

const moduleReducer = (state = initialState, action) => {
  switch (action.type) {
    case MODULE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_MODULES: {
      return {
        ...state,
        modules: [...action.payload],
        loading: false,
        error: null
      }
    }
    case SET_PINNED_MODULES: {
      return {
        ...state,
        pinnedModules: [...(action.payload || [])],
        loading: false,
        error: null
      }
    }
    case GET_MODULES_STRUCTURE: {
      return {
        ...state,
        moduleStructure: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_MODULE:
      return {
        ...state,
        modules: [action.payload, ...state.modules],
        loading: false,
        error: null
      };
    case UPDATE_MODULE:
      const modulesData = state.modules.slice(0);
      const uIndex = modulesData.findIndex((data) => data.id === action.payload.id);
      modulesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        modules: [ ...modulesData ],
        loading: false,
        error: null
      };
    case DELETE_MODULE:
      const modules = state.modules?.slice(0);
      const index = modules.findIndex((data) => data.id === action.id);
      if (index > -1) {
        modules.splice(index, 1);
      }
      return {
        ...state,
        modules: [...modules],
        loading: false,
        error: null
      }
    case MODULE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default moduleReducer;
